import * as React from "react";
const SvgFiRrAssistiveListeningSystems = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-assistive-listening-systems_svg__a)">
      <path
        fill="#062147"
        d="M2 23a1 1 0 1 1-2-.001 1 1 0 0 1 2 0m5-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-7.293 4.293a.999.999 0 1 0-1.414 1.413l4 4a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.413zM23.9 6.086A11.64 11.64 0 0 0 17.877.083a.999.999 0 1 0-.798 1.834A9.64 9.64 0 0 1 22.07 6.89a1 1 0 1 0 1.831-.804zM15 10.999c0 .493-.181.967-.509 1.333a1 1 0 1 0 1.489 1.334A4 4 0 0 0 17 11c0-2.205-1.794-4-4-4a4 4 0 0 0-3.779 2.689.999.999 0 1 0 1.888.656A2.002 2.002 0 0 1 15 11m-2.119-7.998c-4.022.059-7.309 2.98-7.815 6.947a1 1 0 0 0 .866 1.117 1.01 1.01 0 0 0 1.119-.865c.378-2.97 2.843-5.155 5.86-5.2 1.63-.063 3.148.59 4.301 1.726a5.96 5.96 0 0 1 1.789 4.273c0 1.2-.355 2.36-1.028 3.351-.897 1.32-.972 2.577-.972 3.65 0 2.206-1.794 4-4 4a1 1 0 1 0 0 2c3.309 0 6-2.692 6-6 0-.878.047-1.674.627-2.527A7.94 7.94 0 0 0 21.001 11a7.94 7.94 0 0 0-2.385-5.697A7.94 7.94 0 0 0 12.882 3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-assistive-listening-systems_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAssistiveListeningSystems;
